/* eslint-disable */
export default {
  title: 'Région',
  NAOnlyMessage:
    'Veuillez entrer votre indicatif régional. Il sera utilisé pour la composition des numéros locaux.',
  MultiWithNAMessage:
    'Veuillez définir l’indicatif de votre pays et votre indicatif régional. Ils seront utilisés pour la composition des numéros locaux et le formatage des numéros de téléphone.',
  MultiWithoutNAMessage:
    'Veuillez sélectionner le pays correspondant à votre emplacement. Il sera utilisé pour la composition des numéros locaux et le formatage des numéros de téléphone.',
  country: 'Pays',
  areaCode: 'Indicatif régional',
  areaCodePlaceholder: 'Entrer l’indicatif régional',
} as const;

// @key: @#@"title"@#@ @source: @#@"Region"@#@
// @key: @#@"NAOnlyMessage"@#@ @source: @#@"Please set your area code. This will be used for local dialing."@#@
// @key: @#@"MultiWithNAMessage"@#@ @source: @#@"Please set the country and area code for your region. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"MultiWithoutNAMessage"@#@ @source: @#@"Please select the country you locate in. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"country"@#@ @source: @#@"Country"@#@
// @key: @#@"areaCode"@#@ @source: @#@"Area Code"@#@
// @key: @#@"areaCodePlaceholder"@#@ @source: @#@"Enter Area Code"@#@
